import moment from 'moment-timezone';
import Store from '@/store/store.js';
import i18n from '../i18n';
import Vue from 'vue';

export default {
  methods: {
    login() {
      const basePath = window.location.origin.toString();
      Vue.$keycloak.login({ redirectUri: basePath + '/app/dashboard' });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      switch (Store.getters.dateFormat) {
        case 'YYYY-MM-DD':
          return `${year}-${month}-${day}`;
        case 'DD/MM/YYYY':
          return `${day}/${month}/${year}`;
        case 'MM/DD/YYYY':
          return `${month}/${day}/${year}`;
        case 'DD MMM YY':
          return moment(new Date(date)).format('DD MMM YY');
        default:
          return `${day} ${month} ${year}`;
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return null;
      const [date, time] = dateTime.split('T');
      let dateFormatted = this.formatDate(date);
      const [hours, minutes] = time.split(':');
      return `${dateFormatted} ${hours}:${minutes}`;
    },
    formatDateTimeLocale(dateTime) {
      if (!dateTime) return null;
      let dateTimeLocale = moment.utc(dateTime).tz(Store.getters.timezone);
      return this.formatDateTime(dateTimeLocale.format());
    },
    formatDateLocaleAE(dateTime) {
      if (!dateTime) return null;
      let dateTimeLocale = moment.utc(dateTime).tz('Asia/Dubai');
      return dateTimeLocale.format('DD MMM YY');
    },
    parseDate(date) {
      if (!date) return null;
      let splitterChar = '-';
      let year = 0;
      let month = 1;
      let day = 2;
      switch (Store.getters.dateFormat) {
        case 'YYYY-MM-DD':
          break;
        case 'DD/MM/YYYY':
          splitterChar = '/';
          year = 2;
          month = 1;
          day = 0;
          break;
        case 'MM/DD/YYYY':
          splitterChar = '/';
          year = 2;
          month = 0;
          day = 1;
          break;
        default:
          break;
      }
      const dateArray = date.split(splitterChar);
      return `${dateArray[year]}-${dateArray[month].padStart(2, '0')}-${dateArray[day].padStart(
        2,
        '0',
      )}`;
    },
    getNowUtc() {
      return moment.utc().format();
    },
    dateIsAfter(dt1, dt2) {
      if (dt1 && dt2) {
        return moment(dt1).isAfter(moment(dt2));
      }
      return false;
    },
    getSanitizedText(text) {
      if (text) {
        let div = document.createElement('div');
        div.innerHTML = text;
        let textSanitized = div.textContent || div.innerText || '';
        return textSanitized.substring(0, 40);
      } else {
        return null;
      }
    },
    parseJwt(token) {
      let base64Url = token.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(''),
      );
      return JSON.parse(jsonPayload);
    },
    clearLocalStorage() {
      let locale = localStorage.getItem('locale');
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('locale', locale);
    },
    setLocalStorage(res_data_obj) {
      let jwt = this.parseJwt(res_data_obj.access_token);
      localStorage.userid = jwt.userid;
      localStorage.userfullname = jwt.name;
      localStorage.email = jwt.email;
      localStorage.roles = jwt.realm_access.roles;
      if (jwt.avatar) {
        localStorage.avatar = jwt.avatar;
      }
      if (jwt.timezone) {
        localStorage.timezone = jwt.timezone;
      }
      if (jwt.dateformat) {
        localStorage.dateformat = jwt.dateformat;
      }
      localStorage.token = res_data_obj.access_token;
      localStorage.refresh_token = res_data_obj.refresh_token;
      localStorage.expires_in_timestamp = jwt.exp;
      Store.commit('setRoles', localStorage.roles);
      Store.commit('setTimezone', localStorage.timezone);
      Store.commit('setDateFormat', localStorage.dateformat);
      Store.commit('setFullName', localStorage.userfullname);
      Store.commit('setEmail', localStorage.email);
    },
    logout() {
      this.clearLocalStorage();
      Vue.$keycloak.logout({ redirectUri: window.location.origin });
    },
    getDescendantProp(obj, desc) {
      let arr = desc.split('.');
      while (arr.length && (obj = obj[arr.shift()]));
      return obj;
    },
    isTokenExpired(token) {
      let decode = this.parseJwt(token);
      if (decode.exp * 1000 < new Date().getTime()) {
        return true;
      }
      return false;
    },
    createImage(image) {
      return new Promise((resolve, reject) => {
        if (image && image.size > 0) {
          let reader = new FileReader();
          reader.addEventListener(
            'load',
            () => {
              localStorage.imagePath = reader.result;
              Store.commit('setImagePath', reader.result);
              resolve(reader.result);
            },
            false,
          );
          reader.readAsDataURL(image);
        } else {
          reject('no-image');
        }
      });
    },
    timeAgo(timestamp) {
      return moment.utc(timestamp).fromNow();
    },
    markNotificationAsRead(notificationId) {
      return this.axios.post('/api/v1/notifications/' + notificationId + '/read');
    },
    markNotificationAsUnread(notificationId) {
      return this.axios.post('/api/v1/notifications/' + notificationId + '/unread');
    },
    emailRules() {
      return [
        v => !!v || i18n.t('email-required'),
        v => /.+@.+\..+/.test(v) || i18n.t('email-valid'),
      ];
    },
    passwordRules() {
      return [v => !!v || i18n.t('password-required')];
    },
    confirmPasswordRules() {
      return [v => !!v || i18n.t('confirm-password-required')];
    },
    confirmEmailRules() {
      return [
        v => !!v || i18n.t('email-required'),
        v => /.+@.+\..+/.test(v) || i18n.t('email-valid'),
      ];
    },
    // Required rules
    requiredRule() {
      return [v => !!v || this.$i18n.t('required-field')];
    },
    requiredRuleList() {
      return [v => v.length > 0 || this.$i18n.t('field-not-empty')];
    },
    requiredRuleEditor() {
      return [v => v !== '<p></p>' || this.$i18n.t('required-field')];
    },
    i18nEnum: item => i18n.t(item.id),
    i18nEnumEntity: item => i18n.t(item.description),
    minMaxLengthRule(min, max) {
      return [
        v => !!v || this.$i18n.t('required-field'),
        v => (v && v.length >= min) || 'This field must have at least ' + min + ' characters',
        v => (v && v.length <= max) || 'This field exceeds ' + max + ' maximum allowed characters',
      ];
    },
    maxLengthRule(max) {
      return [
        v =>
          !v ||
          (v && v.length <= max) ||
          'This field exceeds ' + max + ' maximum allowed characters',
      ];
    },
    isFirstTime() {
      return sessionStorage.getItem('firstTime')
        ? JSON.parse(sessionStorage.getItem('firstTime'))
        : true;
    },
    getOrderColor(status) {
      switch (status) {
        case 'REQUESTED':
        case 'ACCEPTED_BY_PROVIDER':
        case 'ACCEPTED_BY_RESEARCHER':
          return '#FEF3C7';
        case 'COMPLETED_BY_PROVIDER':
          return '#DCFCE7';
        case 'REJECTED_BY_RESEARCHER':
        case 'REJECTED_BY_PROVIDER':
        case 'INVALIDATED_BY_PROVIDER':
          return '#FEE2E2';
        default:
          return '';
      }
    },
    color(index) {
      const tags = ['neutral200', 'secondary200', 'primary200', 'primary', 'success', 'secondary'];
      return tags[index % tags.length];
    },
    checkURL() {
      return [v => v == null || this.isURL(v) || 'URL is invalid'];
    },
    isURL(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === 'http:' || url.protocol === 'https:';
    },
    countFilters(array) {
      let i = 0;
      Object.keys(array).forEach(key => {
        if (array[key].length > 0) {
          i++;
        }
      });
      return i;
    },
  },
};
